module.exports = __webpack_public_path__ + "static/media/599702_2.b6256d43.pdf";